/**
 * @author Martin Leonov <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Továrna na ovladače pro zobrazování obrázkových souborů.
 */
class PlaylistDeterministicViewerControllerFactory {
  /**
   * Vytvoří instanci.
   * @param {AnalyticsTracker} analyticsTracker
   * @param {ViewerLifeCycleFactory} lifeCycleFactory
   * @param {Class.<PlaylistDeterministicViewerController>} PlaylistDeterministicViewerController
   * @param {Store} store
   * @param {UnixTimestamp} unixTimestamp
   * @param {ViewerSlideFactory} viewerSlideFactory
   */
  constructor(
    analyticsTracker,
    lifeCycleFactory,
    PlaylistDeterministicViewerController,
    store,
    unixTimestamp,
    viewerSlideFactory
  ) {
    this.analyticsTracker = analyticsTracker;
    this.lifeCycleFactory = lifeCycleFactory;
    this.PlaylistDeterministicViewerController =
      PlaylistDeterministicViewerController;
    this.store = store;
    this.unixTimestamp = unixTimestamp;
    this.viewerSlideFactory = viewerSlideFactory;
  }

  /**
   * Vytvoří ovladač.
   * @returns {PlaylistDeterministicViewerController}
   */
  create() {
    return new this.PlaylistDeterministicViewerController(
      this.analyticsTracker,
      this.lifeCycleFactory,
      this.store,
      this.unixTimestamp,
      this.viewerSlideFactory
    );
  }
}

export default PlaylistDeterministicViewerControllerFactory;
